module.exports = __webpack_public_path__ + "img/motivador.6b06d706.png";